export default __webpack_public_path__ + "static/media/unlocking-the-power.png.webp";